import React from 'react';
import { Tooltip } from 'antd';
import { Eye, Monitor, UserPlus, UserMinus, Download, Share2, Trash2 } from 'lucide-react';

const containerStyle = {
  display: 'flex',
  gap: 4,
  height: 32,
  alignItems: 'center',
  justifyContent: 'flex-end',
};

const btnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  borderRadius: 8,
  border: 'none',
  background: 'none',
  backgroundColor: 'transparent',
  color: '#ffffff',
  cursor: 'pointer',
  padding: 0,
  outline: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  appearance: 'none',
};

// Modes that require volumetric data (CT, MR, PT)
const VOLUMETRIC_MODALITIES = ['CT', 'MR', 'PT', 'NM', 'US'];

function getV3Modes(modality) {
  const modes = [{ key: 'viewer', label: 'Basic Viewer' }];
  const mod = (modality || '').toUpperCase();
  if (VOLUMETRIC_MODALITIES.some((m) => mod.includes(m))) {
    modes.push({ key: 'segmentation', label: 'Segmentation' });
  }
  if (mod.includes('PT') && (mod.includes('CT') || mod.includes('MR'))) {
    modes.push({ key: 'tmtv', label: 'Total Metabolic Tumor Volume' });
  }
  return modes;
}

export default function StudyTableActions({
  onView,       // kept in signature for backward compat but no longer used
  onViewV3,
  onOpenWorkstation, // optional: launches the study in the desktop (Weasis) viewer; button hidden when absent
  onAssign,
  onUnassign,
  onDownload,
  onShare,
  onDelete,
  modality,
  viewOnly = false, // read-only roles (e.g. referring physicians): show only the View (Eye) action
}) {
  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `
        .action-icon-btn:hover { background-color: #35383f !important; }
      `}} />
      <div style={{ ...containerStyle, justifyContent: viewOnly ? 'center' : 'flex-end' }}>
        {/* Eye opens AfyaNX Viewer (OHIF v3) — basic viewer mode */}
        <Tooltip title="View Study" placement="top">
          <button className="action-icon-btn" style={btnStyle} onClick={() => onViewV3('viewer')}>
            <Eye size={16} color="#ffffff" />
          </button>
        </Tooltip>
        {/* Hidden for read-only roles, per the contract of viewOnly above: a referring physician
            gets the web viewer, not the diagnostic workstation. This button used to be gated to a
            handful of pilot machines, which masked the fact that it sat outside the viewOnly block;
            now that it ships to everyone, the distinction matters. */}
        {onOpenWorkstation && !viewOnly && (
          <Tooltip title="Open in Desktop Workstation" placement="top">
            <button className="action-icon-btn" style={btnStyle} onClick={onOpenWorkstation}>
              <Monitor size={16} color="#ffffff" />
            </button>
          </Tooltip>
        )}
        {!viewOnly && (
          <>
            <Tooltip title="Assign to Radiologist" placement="top">
              <button className="action-icon-btn" style={btnStyle} onClick={onAssign}>
                <UserPlus size={16} color="#ffffff" />
              </button>
            </Tooltip>
            <Tooltip title="Unassign Radiologist" placement="top">
              <button className="action-icon-btn" style={btnStyle} onClick={onUnassign}>
                <UserMinus size={16} color="#ffffff" />
              </button>
            </Tooltip>
            <Tooltip title="Download Study" placement="top">
              <button className="action-icon-btn" style={btnStyle} onClick={onDownload}>
                <Download size={16} color="#ffffff" />
              </button>
            </Tooltip>
            <Tooltip title="Share Study" placement="top">
              <button className="action-icon-btn" style={btnStyle} onClick={onShare}>
                <Share2 size={16} color="#ffffff" />
              </button>
            </Tooltip>
            <Tooltip title="Delete Study" placement="top">
              <button className="action-icon-btn" style={btnStyle} onClick={onDelete}>
                <Trash2 size={16} color="#ffffff" />
              </button>
            </Tooltip>
          </>
        )}
      </div>
    </>
  );
}
